import React from "react";
import { useTheme } from "../context/ThemeContext";
import logoDark from "../images/logoForDarkTheme.png";
import logoLight from "../images/logoForLightTheme.png";

export function Logo({ type = "full", width, height, style, className, theme: themeProp, forceTheme, ...props }) {
  const { theme: contextTheme } = useTheme();

  const activeTheme = forceTheme || themeProp || contextTheme || "dark";

  const getLogo = () => {
    return activeTheme === "dark" ? logoDark : logoLight;
  };

  const getDefaultSize = () => {
    if (type === "icon") {
      return { width: "40px", height: "40px" };
    }
    return { width: "120px", height: "40px" };
  };

  const defaultSize = getDefaultSize();
  const finalStyle = {
    ...defaultSize,
    objectFit: "contain",
    transition: "opacity 0.3s ease",
    ...style,
  };

  if (width) finalStyle.width = width;
  if (height) finalStyle.height = height;

  return (
    <img
      src={getLogo()}
      alt="HealrMed"
      style={finalStyle}
      className={className}
      {...props}
    />
  );
}

export default Logo;
